import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class VitalRequestsViewDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta la informacion de la vista renderizada
   *
   * @param {number} idView
   * @param {number} idTramite
   * @returns {Observable<any[]>}
   * @memberof VitalRequestsViewDataService
   */
  getDataTables(id_view:number): Observable<any[]> {
    return new Observable(obs => {
      this.http.get<any[]>(this.api.get('ViewVital',[id_view])).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Iniciar los procesos de destino asociados a los procesos de origen
   * asignando el usuario actual
   *
   * @param {number} idView
   * @param {number[]} process_id
   * @returns {Observable<boolean>}
   * @memberof VitalRequestsViewDataService
   */
  initProcess( idView: number[]): Observable<boolean> {
    return new Observable(obs => {
      const formData = {
        id_view: idView
      };
      this.http.post<any>(this.api.get('ViewVital'), formData).subscribe(
        _data => {
          this.toastr.success('Tramite iniciado correctamente', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/view-vital-requests/shared/view-vital-requests.data.service.ts